import type { FacilityTemplateOverridePayload } from '@Application/Documents/TemplateAssignments/Actions/facilityTemplateOverridesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `facilityId` is read off the `facility` relation (`{ id }`). The facility's name is not on this
 * payload: it is resolved against `facilitiesStore` by the consuming screen, with a
 * "Agence n° {id}" fallback when it is absent there. `documentTypeId` is read off the `documentType`
 * relation (`{ id }`); the label is resolved against `DocumentTypesListView.labelOf`.
 */
class FacilityTemplateOverrideView {
	readonly id: number;
	readonly facilityId: number;
	readonly documentTypeId: number;
	readonly templateId: number;

	constructor(payload: FacilityTemplateOverridePayload) {
		this.id = payload.id;
		this.facilityId = payload.facility.id;
		this.documentTypeId = payload.documentType.id;
		this.templateId = payload.template.id;

		Object.freeze(this);
	}
}

export default FacilityTemplateOverrideView;
